import { IStaffsParams } from './types/api';
import { ISalaryInfo } from './types/staffSalary';

export const NAME_REDUCER = 'setting_staff';

export const PREFIX_ACTIONS = 'setting_staff_feature_';

export const PATH_LOADING = {
  getData: `loading.${NAME_REDUCER}.getData`,
  getStaffList: `loading.${NAME_REDUCER}.getStaffList`,
  getStaffDetails: `loading.${NAME_REDUCER}.getStaffDetails`,
};
export enum ESalaryPayrollType {
  // NONE = 'NONE',
  // ADD_TO_CHECK = 'ADD_TO_CHECK',
  // ADD_TO_CASH = 'ADD_TO_CASH',
  // ADD_TO_CHECK_SUBTRACT_FROM_CASH = 'ADD_TO_CHECK_SUBTRACT_FROM_CASH',
  // BY_DEFINED_PERCENTAGE = 'BY_DEFINED_PERCENTAGE',
  DEFAULT = '1099',
  W2 = 'W-2',
}

export enum STAFF_POSITION {
  ADMIN = 'ADMIN',
  OTHER = 'OTHER',
  TECHNICAL = 'TECHNICAL',
  CASHIER = 'CASHIER',
}
export enum STAFF_STATUS {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE',
  DELETE = 'DELETE',
}
export enum STAFF_POSITION_INFO {
  ADMIN = 'ADMIN',
  TECHNICAL = 'TECHNICAL',
  CASHIER = 'CASHIER',
  MANAGER = 'MANAGER',
}

export const enum ESalaryMode {
  COMMISSION = 'COMMISSION',
  HOURS = 'HOURS',
  DAYS = 'DAYS',
  COMMISSION_ACCELERATE = 'COMMISSION_ACCELERATE',
  FIX_SALARY = 'FIX_SALARY',
}
export const enum CALENDAR_PICKER_TYPE {
  DATE = 'date',
  WEEK = 'week',
  MONTH = 'month',
}

export const initSalaryInfo: ISalaryInfo = {
  salaryMode: ESalaryMode.COMMISSION,
  commission_accelerate: [{ from: '', to: '', commission: '' }],
  commission: '',
  cash: '',
  check: '',
  specialFee: '',
  // selectedTipMethod: SalaryPayrollTipOption.NONE,
  tipFee: '',
  payrollCash: '',
  payrollCheck: '',
};

export const getStaffPositionLabel = (val: STAFF_POSITION_INFO) => {
  switch (val) {
    case STAFF_POSITION_INFO.ADMIN: return 'ADMIN';
    case STAFF_POSITION_INFO.CASHIER: return 'RECEPTIONIST';
    case STAFF_POSITION_INFO.MANAGER: return 'MANAGER';
    case STAFF_POSITION_INFO.TECHNICAL: return 'TECHNICIAN';
    default: return '';
  }
};

export const positionsArray = Object.entries(STAFF_POSITION_INFO).map(
  ([key, value]) => ({
    label: getStaffPositionLabel(value),
    value: key,
  })
);


export const initStaffsParams: IStaffsParams = {
  keySearch: '',
  status: STAFF_STATUS.ACTIVE,
  page: 1,
  size: 9,
};